import React, { useState } from 'react';
import AdminLayout from '../AdminLayout';
import './AdminSettings.css';

const AdminSettings = () => {
  const [settings, setSettings] = useState({
    siteTitle: 'Densat Cleaning Services',
    siteDescription: 'Professional cleaning and maintenance services',
    contactEmail: 'info@densat.com',
    contactPhone: '+1 (555) 123-4567',
    enableNotifications: true,
    enableAnalytics: false,
    maintenanceMode: false
  });

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setSettings(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Settings saved:', settings);
    // Here you would typically save to backend
    alert('Settings saved successfully!');
  };

  const handleReset = () => {
    setSettings({
      siteTitle: 'Densat Cleaning Services',
      siteDescription: 'Professional cleaning and maintenance services',
      contactEmail: 'info@densat.com',
      contactPhone: '+1 (555) 123-4567',
      enableNotifications: true,
      enableAnalytics: false,
      maintenanceMode: false
    });
  };

  return (
    <AdminLayout>
      <div className="admin-settings">
      <div className="settings-header">
        <h1>Admin Settings</h1>
        <p>Configure your application settings and preferences</p>
      </div>

      <form onSubmit={handleSubmit} className="settings-form">
        <div className="settings-section">
          <h2>General Settings</h2>
          <div className="form-group">
            <label htmlFor="siteTitle">Site Title</label>
            <input
              type="text"
              id="siteTitle"
              name="siteTitle"
              value={settings.siteTitle}
              onChange={handleInputChange}
            />
          </div>
          <div className="form-group">
            <label htmlFor="siteDescription">Site Description</label>
            <textarea
              id="siteDescription"
              name="siteDescription"
              value={settings.siteDescription}
              onChange={handleInputChange}
              rows="3"
            />
          </div>
        </div>

        <div className="settings-section">
          <h2>Contact Information</h2>
          <div className="form-group">
            <label htmlFor="contactEmail">Contact Email</label>
            <input
              type="email"
              id="contactEmail"
              name="contactEmail"
              value={settings.contactEmail}
              onChange={handleInputChange}
            />
          </div>
          <div className="form-group">
            <label htmlFor="contactPhone">Contact Phone</label>
            <input
              type="tel"
              id="contactPhone"
              name="contactPhone"
              value={settings.contactPhone}
              onChange={handleInputChange}
            />
          </div>
        </div>

        <div className="settings-section">
          <h2>Features & Preferences</h2>
          <div className="checkbox-group">
            <label className="checkbox-label">
              <input
                type="checkbox"
                name="enableNotifications"
                checked={settings.enableNotifications}
                onChange={handleInputChange}
              />
              <span className="checkmark"></span>
              Enable Email Notifications
            </label>
          </div>
          <div className="checkbox-group">
            <label className="checkbox-label">
              <input
                type="checkbox"
                name="enableAnalytics"
                checked={settings.enableAnalytics}
                onChange={handleInputChange}
              />
              <span className="checkmark"></span>
              Enable Analytics Tracking
            </label>
          </div>
          <div className="checkbox-group">
            <label className="checkbox-label">
              <input
                type="checkbox"
                name="maintenanceMode"
                checked={settings.maintenanceMode}
                onChange={handleInputChange}
              />
              <span className="checkmark"></span>
              Maintenance Mode (Site will be offline)
            </label>
          </div>
        </div>

        <div className="form-actions">
          <button type="submit" className="save-btn">Save Settings</button>
          <button type="button" className="reset-btn" onClick={handleReset}>Reset to Defaults</button>
        </div>
      </form>
    </div>
    </AdminLayout>
  );
};

export default AdminSettings;
